import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { Industry } from '../../../types/toppage';
import { getIndustries } from '../../../services/toppage';

export const Component: FunctionComponent = () => {
  const [industries, setIndustries] = useState<Industry[]>([]);

  useEffect(() => {
    const request = async () => {
      const data = await getIndustries();
      setIndustries(data);
    };
    request();
  }, []);

  return <Presentation industries={industries} />;
};
